import React from 'react';
import styled from 'styled-components';
import 'react-day-picker/dist/style.css';
interface CustomTableProps {
  tableHeader: string[];
  renderTableItem: () => JSX.Element;
}

const CustomTable: React.FC<CustomTableProps> = ({ tableHeader, renderTableItem }) => {
  return (
    <Style>
      <div className="listWrap">
        <div className="listTitle">
          {tableHeader.map((header, index) => (
            <h2 key={index}>{header}</h2>
          ))}
        </div>
        {renderTableItem()}
      </div>
    </Style>
  );
};

export default CustomTable;

const Style = styled.div`
  .listWrap {
    border: 1px solid #e5e5e5;
    border-radius: 5px;

    .listTitle {
      display: inline-flex;

      h2 {
        text-align: center;
      }
    }
    .listTitle,
    .listContent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 25px;
      background: #f7f7f7;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      text-align: center;
      gap: 5px;

      h2 {
        font-size: 16px;
        font-weight: 500;
        color: #2b2b2b;
        text-align: center;
      }

    }
    .listContent {
      border-radius: 0;
      background: none;
      border-top: 1px solid #e5e5e5;

      p {
        font-size: 13px;
        font-weight: 500;
        color: #555;
      }
    }
  }
`;
